import { getUrlParams, getValidPath } from './index';

const TRACKER_KYC_UTM_SOURCE = 'tracker';
const TRACKER_KYC_UTM_MEDIUM = 'complete_kyc';
const TRACKER_KYC_UTM_CAMPAIGN = 'pending_customer_kyc';

export const isPendingCustomerKyc = (status: any) => {
  return String(status || '').trim().toLowerCase() === 'pending customer kyc';
};

export const extractKycRedirectUrl = (data: any): string => {
  const possibleUrl =
    data?.kyc_url ||
    data?.redirect_url ||
    data?.url ||
    data?.link ||
    data?.kyc?.url ||
    data?.kyc?.redirect_url ||
    data?.kyc?.link ||
    data?.customer?.kyc_url ||
    data?.customer?.redirect_url ||
    data?.customer?.url ||
    data?.customer?.link ||
    data?.customer_details?.kyc_url ||
    data?.customer_details?.redirect_url ||
    data?.customer_details?.url ||
    data?.customer_details?.link;

  return typeof possibleUrl === 'string' ? possibleUrl.trim() : '';
};

export const navigateToKycUrl = (router: any, url: string) => {
  if (!url) {
    return;
  }

  if (/^https?:\/\//i.test(url)) {
    window.location.href = url;
    return;
  }

  router.push(getUrlParams(getValidPath(url), router));
};

const getQueryValue = (value: any) => {
  if (Array.isArray(value)) {
    return value[0] || '';
  }
  return typeof value === 'string' ? value : '';
};

export const getTrackerKycLoginParams = () => {
  return `from=otpLogin&utm_source=${TRACKER_KYC_UTM_SOURCE}&utm_medium=${TRACKER_KYC_UTM_MEDIUM}&utm_campaign=${TRACKER_KYC_UTM_CAMPAIGN}`;
};

export const isTrackerKycLoginFlow = (query: any) => {
  return (
    getQueryValue(query?.utm_source) === TRACKER_KYC_UTM_SOURCE &&
    getQueryValue(query?.utm_medium) === TRACKER_KYC_UTM_MEDIUM &&
    getQueryValue(query?.utm_campaign) === TRACKER_KYC_UTM_CAMPAIGN
  );
};
